// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/paragraph/ParagraphStaticForm.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/paragraph/ParagraphStaticForm.tsx");
  import.meta.hot.lastModified = "1740183864616.3552";
}
// REMIX HMR END

import { useFetcher } from "@remix-run/react";
import { Fragment, useEffect, useState } from "react";
import Button from "../Button";
import IconResolver from "../IconResolver";
import { formBlockMap } from "../forms/Blocks";
import { formatTitleForTableOfContent } from "~/utils/utils";
import { Heading } from "..";
export function isSupportedForm(form) {
  return form in formBlockMap;
}
export default function StaticForm({
  form,
  imageOptional,
  postActionText,
  preSelectedValue,
  textOptional,
  title
}) {
  _s();
  const fetcher = useFetcher();
  const [showForm, setShowForm] = useState(true);
  useEffect(() => {
    if (fetcher.state === "loading" && fetcher.data?.success) {
      setShowForm(false);
    }
  }, [fetcher.state, fetcher.data?.success]);
  const FormComponent = formBlockMap[form];
  return <section className="flex flex-col items-center w-full !max-w-lg">
      {showForm ? <Fragment>
          {imageOptional && <img src={imageOptional.mediaImage.url} alt={imageOptional.mediaImage.alt} className="w-[120px] h-[120px] mb-4" />}
          <Heading tag="h2" id={formatTitleForTableOfContent(title)} className="text-center">
            {title}
          </Heading>
          {textOptional && <div className="text-neutral-600 mb-4 text-center" dangerouslySetInnerHTML={{
        __html: textOptional.processed
      }} />}
          <FormComponent fetcher={fetcher} preSelectedValue={preSelectedValue} />
        </Fragment> : <Fragment>
          <div className="mb-4 group relative w-10 h-12 after:absolute after:opacity-0 hover:after:opacity-100 after:content-[url('/assets/logo/icon_hover.svg')] after:transition-opacity after:duration-300">
            <img src="/assets/logo/icon_plain.svg" alt="Octahedroid Logo" aria-hidden="true" className="absolute opacity-100 group-hover:opacity-0 transition-opacity duration-300" />
          </div>
          <h2 className="text-2xl font-semibold mb-4 text-primary-700">
            Thank you
          </h2>
          {postActionText && <div className="text-neutral-600 mb-4 text-center" dangerouslySetInnerHTML={{
        __html: postActionText.processed
      }} />}
          <Button className="flex items-center" variant="secondary" type="button" onClick={() => setShowForm(true)}>
            <Fragment>
              <IconResolver className="w-5 h-5 mr-4" token="arrow-narrow-left" />
              Back
            </Fragment>
          </Button>
        </Fragment>}
    </section>;
}
_s(StaticForm, "EEXEzp8Q+CIaH8McyxlKNRg8DX0=", false, function () {
  return [useFetcher];
});
_c = StaticForm;
var _c;
$RefreshReg$(_c, "StaticForm");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;